import { render, staticRenderFns } from "./AnnouncementBar.vue?vue&type=template&id=3c17e26b&scoped=true"
import script from "./AnnouncementBar.vue?vue&type=script&lang=js"
export * from "./AnnouncementBar.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementBar.vue?vue&type=style&index=0&id=3c17e26b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c17e26b",
  null
  
)

export default component.exports